module.exports = __webpack_public_path__ + "static/media/kid-stirring-ingredients.1cd7e865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-stirring-ingredients.jpg
// module id = 811
// module chunks = 0